const support = {
    towni: {
        supportEmail: "support@towni.se",
        contactEmail: "kontakt@towni.se",
        phoneNumber: "+46731502321",
    },
    destio: {
        supportEmail: "support@destio.se",
        contactEmail: "kontakt@destio.se",
        phoneNumber: "+46731502321",
    },
    alfred: {
        supportEmail: "support@hejalfred.se",
        phoneNumber: "+46731502321",
        companyName: "Alfred Technologies AB",
        address: "Silversköldsgatan 1",
        zipCode: "531 31",
        city: "Lidköping",
        country: "Sverige",
        orgNr: "559244-9515",
        vatNr: "SE559244951501",
        invoicesEmail: "invoices@hejalfred.se",
    },
};

export { support };
